import Financial from '../../services/financial';
import Sales from '../../services/sales';
import Contracts from '../../services/contracts'
import successPage from '../common/adhesion/success.vue'
import errorPage from '../common/adhesion/error.vue'
import GenericSummary from '../common/generic-summary.vue'
import auth from '../../services/auth'

export default {
  data(){
    return {
      salesOrder: undefined,
      loading: undefined,
      code: undefined,
      novoCartao: false,
      contractId: undefined,
      vads_action_mode:"INTERACTIVE",
      vads_amount:"1",
      vads_ctx_mode:undefined,
      vads_currency:"986",
      vads_url_return:"https://movemais.com",
      vads_cust_country:"BR",
      vads_cust_name:undefined,
      vads_cust_email:undefined,
      vads_cust_first_name:undefined,
      vads_cust_last_name:undefined,
      vads_cust_national_id:undefined,
      vads_page_action:"PAYMENT",
      vads_payment_cards:"PIX",
      vads_payment_config:"SINGLE",
      vads_order_id:undefined,
      vads_site_id:undefined,
      vads_order_info:undefined,
      vads_trans_date: undefined,
      vads_trans_id: undefined,
      vads_version:"V2",
      certificate: undefined,
      signature:undefined,
      newPix: false,
      pixCopiaCola: undefined,
      hideButton: undefined,
      step: 0,
      validacaoFraude: undefined,
      cpmId: undefined,
      usuario: undefined,
      validado: undefined,
      planId: undefined,
      contract: undefined,
    }
  },
  computed: {
    orderId(){
      return this.$route.params.orderId
    },
    user() {
      return auth.currentUser;
    }
  },
  mounted() {
    if (this.orderId) {
      let promise = Sales.getSalesOrderId(this.orderId).then((result) => {
        this.salesOrder = result.order;

          this.salesOrder.totalComDesconto = this.salesOrder.price;
          if(this.salesOrder.promotionCode && this.salesOrder.promotionCode.indexOf('SENFF') >=0) {
            sessionStorage.setItem('promoCheck', '#SENFF2020');
          }
        return Contracts.getContractByContractId(result.order.contractId).then(r => {
          this.salesOrder = result.order;

          this.salesOrder.totalComDesconto = this.salesOrder.price;
          this.$set(this.salesOrder, 'contract', result.order.contractId);
          this.contract = r;
          this.salesOrder.planId = r.plan.planId;
          this.planId = r.plan.planId;
        });
      }).catch((error) => {

        if(error.data.status && error.data.status.code == 9990){
          return false;
        }
      });
      this.$store.dispatch('loading', promise);
    }
  },
  methods: {
    ConvertFieldToUTF8(){
      this.vads_cust_first_name = encodeURIComponent(this.vads_cust_first_name.replace(/ /g, ""));
      this.vads_cust_last_name = encodeURIComponent(this.vads_cust_last_name.replace(/ /g, ""));
      this.vads_cust_name = encodeURIComponent(this.vads_cust_name.replace(/ /g, ""));
      if (!this.vads_cust_first_name) this.vads_cust_first_name = ".";
      if (!this.vads_cust_last_name) this.vads_cust_last_name = ".";
      if (!this.vads_cust_name) this.vads_cust_name = ".";
   },

      ReceberHash(){
      this.ConvertFieldToUTF8();

      var input_str = this.vads_action_mode +"+"
      + this.vads_amount +"+"
      + this.vads_ctx_mode +"+"
      + this.vads_currency +"+"
      + this.vads_cust_country +"+"
      + this.vads_cust_email +"+"
      + this.vads_cust_first_name +"+"
      + this.vads_cust_last_name +"+"
      + this.vads_cust_name +"+"
      + this.vads_cust_national_id +"+"
      + this.vads_order_id +"+"
      + this.vads_order_info +"+"
      + this.vads_page_action +"+"
      + this.vads_payment_cards +"+"
      + this.vads_payment_config +"+"
      + this.vads_site_id +"+"
      + this.vads_trans_date +"+"
      + this.vads_trans_id  + "+"
      + this.vads_url_return +"+"
      + this.vads_version +"+"
      + this.certificate ;

      const crypto = require('crypto');

      this.signature = crypto.createHmac('sha256', this.certificate).update(input_str).digest('base64');

      this.$forceUpdate();
    },
    getPayment(){
      const cpmFromResponse = (res) => (res.salesOrder && res.salesOrder.contractPaymentMethod) ? res.salesOrder.contractPaymentMethod : null;

      this.loading = Financial.reprocessPayout({salesOrderId: this.orderId}).then(res=>{
        const cpm = cpmFromResponse(res);

        if((this.planId == 21 || this.planId == 22 || this.planId == 35 || this.planId == 36)
        && cpm && cpm.contractPaymentMethodId == null){
          this.novoCartao = true;
        }

        if (cpm) {
          this.usuario = cpm.usuario;
          this.validado = cpm.validado;
        }
        this.vads_site_id = res.info_st
        this.certificate = res.info_cc

        if (res.salesOrder && res.salesOrder.pixCopiaCola) this.pixCopiaCola = res.salesOrder.pixCopiaCola;

        const pmId = cpm && cpm.paymentMethod ? cpm.paymentMethod.paymentMethodId : null;
        if (pmId == 120 && this.pixCopiaCola != undefined){
            this.newPix = true;
            this.salesResponse = res.salesOrder;
            this.code = res.status.code;
            this.boletoUrl = res.boletoUrl;
        } else if (pmId == 120){

          var pedido = res.nextVal.toString();
       if(window.location.hostname == "www.movemais.com" || window.location.hostname == "movemais.com"){
        this.vads_ctx_mode = "PRODUCTION";
       }
       else{
        this.vads_ctx_mode = "TEST";

       }



          this.vads_trans_date = new Date(res.salesOrder.lastUpdateDate).toISOString().replace(/[^0-9]/g,'').substring(0,14);
          this.vads_trans_id = "M"+pedido.slice(-5);
          this.vads_order_id = pedido
          this.vads_order_info = res.info_cp
          this.vads_amount = res.salesOrder.price;

          if (auth.currentUser.person) {
            var sobrenome = auth.currentUser.person.lastName.split(" ", 2);
            this.vads_cust_first_name = auth.currentUser.person.name;
            this.vads_cust_last_name = sobrenome[0];
            this.vads_cust_name = auth.currentUser.person.name;
          }else if(auth.currentUser.company){
            var nome = auth.currentUser.company.companyTradeName.split(" ", 2);
            this.vads_cust_first_name = nome[0];
            this.vads_cust_last_name  = nome[1] ? nome[1] : nome[0];
            this.vads_cust_name = nome[0];
          }
          this.vads_cust_national_id = auth.currentUser.taxIdNumber;
          this.vads_cust_email = auth.currentUser.accountAuthentication.login;

          this.ReceberHash();

          this.newPix= true;
        setTimeout(() => {
          document.getElementById("formPix").submit();
          this.salesResponse = res.salesOrder;
          this.code = res.status.code;
          this.boletoUrl = res.boletoUrl;
        }, 200);
      }else {
        if(res.status){
          this.code = res.status.code;
          this.hideButton = true;
        }
      }

      }).catch(err => {

        this.hideButton=true;
        this.salesOrder = err.data.salesOrder;

        const errCpm = this.salesOrder && this.salesOrder.contractPaymentMethod;
        if (errCpm && errCpm.paymentMethod){
            this.cpmId = errCpm.paymentMethod.paymentMethodId
        }

        this.code = err.data && err.data.status && err.data.status.code;
        var contrato = err.data.salesOrder.contractId;
        var salesOrderId = err.data.salesOrder.salesOrderId;
        var paymentMethodId = errCpm && errCpm.contractPaymentMethodId;

        if (paymentMethodId != null) {
          this.loading = Sales.validarFraudeContrato(contrato,salesOrderId, paymentMethodId).then(r =>{
            if(r.result ){
              this.validacaoFraude = true;
            }else{
              this.validacaoFraude = false;
            }
          })
        } else {
          this.validacaoFraude = false;
        }
      })
    },
    goToStep(value) {
      this.code = undefined;
      this.step = value;
    },
  },


  beforeDestroy(){

    sessionStorage.removeItem('promoCheck');
  },

  components:{
    GenericSummary,
    successPage,
    errorPage
  }
}



// WEBPACK FOOTER //
// ./src/pages/account/reprocess-order.js